import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const ATLBTLDigitalSpendChart: React.FC = () => {
  const data = [{
    channel: 'TV Campaigns',
    atl: 82.5,
    btl: 0,
    digital: 0
  }, {
    channel: 'Print Media',
    atl: 45.8,
    btl: 0,
    digital: 0
  }, {
    channel: 'Radio',
    atl: 28.3,
    btl: 0,
    digital: 0
  }, {
    channel: 'Events',
    btl: 52.4,
    atl: 0,
    digital: 0
  }, {
    channel: 'Trade Shows',
    btl: 38.6,
    atl: 0,
    digital: 0
  }, {
    channel: 'Direct Mail',
    btl: 22.8,
    atl: 0,
    digital: 0
  }, {
    channel: 'Social Media',
    digital: 48.2,
    atl: 0,
    btl: 0
  }, {
    channel: 'Search Ads',
    digital: 35.7,
    atl: 0,
    btl: 0
  }, {
    channel: 'Display Ads',
    digital: 28.4,
    atl: 0,
    btl: 0
  }, {
    channel: 'Email',
    digital: 21.4,
    atl: 0,
    btl: 0
  }];
  return <Card className="p-6" data-id="element-6731">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6732">
        ATL vs BTL vs Digital Spend
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-6733">
        Channel-wise marketing spend (₹ Lakhs)
      </p>
      <ResponsiveContainer width="100%" height={350} data-id="element-6734">
        <BarChart data={data} layout="horizontal" data-id="element-6735">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-6736" />
          <XAxis type="number" tick={{
          fontSize: 12
        }} data-id="element-6737" />
          <YAxis dataKey="channel" type="category" width={100} tick={{
          fontSize: 11
        }} data-id="element-6738" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => `₹${value}L`} data-id="element-6739" />
          <Legend data-id="element-6740" />
          <Bar dataKey="atl" fill="#3b82f6" name="ATL" stackId="a" data-id="element-6741" />
          <Bar dataKey="btl" fill="#10b981" name="BTL" stackId="a" data-id="element-6742" />
          <Bar dataKey="digital" fill="#f59e0b" name="Digital" stackId="a" data-id="element-6743" />
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6744">
        <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-6745">
          <div className="text-center" data-id="element-6746">
            <div className="text-gray-600" data-id="element-6747">ATL Total</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-6748">₹156.6L</div>
          </div>
          <div className="text-center" data-id="element-6749">
            <div className="text-gray-600" data-id="element-6750">BTL Total</div>
            <div className="text-xl font-bold text-green-600" data-id="element-6751">₹113.8L</div>
          </div>
          <div className="text-center" data-id="element-6752">
            <div className="text-gray-600" data-id="element-6753">Digital Total</div>
            <div className="text-xl font-bold text-orange-600" data-id="element-6754">₹133.7L</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default ATLBTLDigitalSpendChart;